import { render, staticRenderFns } from "./ReceptionStorage.vue?vue&type=template&id=1e76a4c5"
import script from "./ReceptionStorage.vue?vue&type=script&lang=js"
export * from "./ReceptionStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports